import { Injectable } from '@angular/core';
import { PaymentsService as ApiPaymentsService } from '@ducat-pro-payments/swag-payments';

import { createApi } from '../utils';

@Injectable({
    providedIn: 'root',
})
export class PaymentsService extends createApi(ApiPaymentsService) {}
